import React from "react";
import Vendor from "./Vendors";

export const ArchiveVendors = () => {
  return <Vendor type="Archived Vendors" />;
};

export default ArchiveVendors;
